import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("seguridad-social/emisiones/find", { params: parametros })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    descargarIMSS(parametros) {
        return Vue.axios.post("seguridad-social/emisiones/descargar-imss", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    },
    descargarArchivo(parametros) {
        return Vue.axios.get("seguridad-social/emisiones/descargar-archivo", {
            params: parametros,
            responseType: 'blob'
        })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
    },
    descargaMasiva(parametros, responseType = null) {
        return Vue.axios.post("seguridad-social/emisiones/descarga-masiva", parametros, {
            responseType: responseType
        })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error));
    },
    inicializarPeriodos(parametros) {
        return Vue.axios.post("seguridad-social/emisiones/inicializar-periodos", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    }
}
